import { Skeleton } from "@/components/ui/skeleton";

export default function RoofCustomersSkeleton() {
  return (
    <div className="px-4 sm:px-6 py-6 sm:py-10 w-full max-w-7xl mx-auto space-y-6">
      <Skeleton className="h-8 w-1/3 " />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className="lg:col-span-8 space-y-4">
          <Skeleton className="h-[80px] w-full rounded-2xl " />
          <Skeleton className="h-[400px] w-full rounded-2xl " />
        </div>

        <div className="lg:col-span-4 space-y-4">
          <Skeleton className="h-[80px] w-full rounded-2xl " />
          {/* <Skeleton className="h-[250px] w-full rounded-2xl " />
          <Skeleton className="h-[150px] w-full rounded-2xl " /> */}
          <Skeleton className="h-[290px] w-full rounded-2xl " />
        </div>
      </div>
    </div>
  );
}
